import { HttpInterceptorFn } from '@angular/common/http';
import { LOCAL_STORAGE } from '../../constants/localstorage-enum';
import { HTTP_HTTPS_REGEX } from '../../constants/system-constants.model';

export const CustomHeadersInterceptor: HttpInterceptorFn = (request, next) => {
  if (!HTTP_HTTPS_REGEX.test(request.url) && !request.url.includes('assets/')) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const language = localStorage.getItem(LOCAL_STORAGE.CURRENT_LANGUAGE);

    const modifiedHeaders = request.headers
      .set('timezone', timezone)
      .set('language', language || '');

    const modifiedReq = request.clone({ headers: modifiedHeaders });
    return next(modifiedReq);
  }
  return next(request);
};
